import React from "react";
import { Link, useLocation } from "react-router-dom";
import { Phone, Calendar } from "lucide-react";

const HIDDEN_ROUTES = ["/admin", "/dashboard", "/login", "/register", "/forgot-password", "/reset-password"];
const PHONE_NUMBER = "+16616668041";

export function StickyMobileCTA() {
  const { pathname } = useLocation();
  const hide = HIDDEN_ROUTES.some((p) => pathname.startsWith(p));
  if (hide) return null;
  return (
    <div
      data-testid="sticky-mobile-cta"
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 border-t border-[#DAD5E2] bg-white/95 backdrop-blur-md shadow-[0_-8px_24px_-8px_rgba(43,35,64,0.15)]"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="grid grid-cols-2 gap-2 p-3">
        <a
          href={`tel:${PHONE_NUMBER}`}
          data-testid="sticky-cta-call"
          className="flex items-center justify-center gap-2 py-3 rounded-full border border-[#2B2340] text-[#2B2340] font-medium text-sm"
        >
          <Phone className="w-4 h-4" strokeWidth={2} />
          Call
        </a>
        <Link
          to="/consultation"
          data-testid="sticky-cta-consult"
          className="flex items-center justify-center gap-2 py-3 rounded-full text-[#1A1A1A] font-semibold text-sm shadow-sm bg-gradient-to-r from-[#DCC17C] to-[#C6A15B]"
        >
          <Calendar className="w-4 h-4" strokeWidth={2} />
          Book Free Consultation
        </Link>
      </div>
    </div>
  );
}
